import React from 'react'
import { Avatar, Box, Button, Typography } from '@mui/material'
import { BellSimple, Lightning, MagnifyingGlass } from '@phosphor-icons/react'
import { BaseNotificationModal } from './base-modal'
import { useStyles } from './style'

/* Changelog modal — the board idea is explicitly "What's new modal on launch".
 * TODO(API): items are hardcoded; a release-notes source (CMS or API) should
 * feed them once one exists. */
const WHATS_NEW_ITEMS = [
  { Icon: Lightning, title: 'Faster article pages', body: 'Articles now open noticeably faster — even on a slow connection.' },
  { Icon: BellSimple, title: 'A calmer notification panel', body: 'Spot what’s new at a glance, and mark everything read in one tap.' },
  { Icon: MagnifyingGlass, title: 'Better search', body: 'Your filters now stay selected while you search.' }
]

export const WhatsNewModal = ({ open, onClose }) => {
  const classes = useStyles()
  return (
    <BaseNotificationModal
      open={open}
      onClose={onClose}
      eyebrow='Product update'
      title="What's new in Mindtools"
      layout='side'
      hero={{
        // Same brand asset as the what's-new email template — modal and email
        // tell one story. The 960×899 near-square source suits the side column.
        src: 'https://www.mindtools.com/wp-content/uploads/2025/10/New_hero_7-e1761053082855-960x0-c-center.webp',
        alt: ''
      }}
      dataTest='notification-modal-whats-new'
    >
      <Typography color='textSecondary' className={classes.intro}>
        Not just new features — this round is the polish you asked for:
      </Typography>
      {WHATS_NEW_ITEMS.map(({ Icon, title, body }) => (
        <Box key={title} className={classes.featureRow}>
          <Box className={classes.featureTile} aria-hidden='true'>
            <Icon size={20} weight='duotone' />
          </Box>
          <Box>
            <Typography className={classes.rowTitle}>{title}</Typography>
            <Typography variant='body2' color='textSecondary' className={classes.rowBody}>{body}</Typography>
          </Box>
        </Box>
      ))}
      {/* Minimal testimonial signature — same quote as the marketing site's
          "Trusted by Our Customers" carousel. */}
      <Box className={classes.testimonial}>
        <Avatar className={classes.testimonialAvatar} aria-hidden='true'>D</Avatar>
        <Box>
          <Typography variant='body2' className={classes.testimonialQuote}>
            “I started using Mindtools a number of years ago as I felt I wasn’t getting
            good enough support and training through my workplace. I have found it
            valuable ever since.”
          </Typography>
          <Typography variant='caption' className={classes.testimonialName}>
            Don, New Zealand
          </Typography>
        </Box>
      </Box>
      <Box className={classes.ctaRow}>
        <Button variant='contained' color='primary' onClick={onClose} data-test='notification-whats-new-cta'>
          Got it
        </Button>
      </Box>
    </BaseNotificationModal>
  )
}

export default WhatsNewModal
